import React, { Component } from "react";

class YesNoRadioButton extends Component {
    constructor(props) {
        super(props);
    }

    handleChange = (e, value) => {
        const {  dataname } = this.props;
        if (this.props.rules.editable) {
           this.props.handleChange(dataname, value)
        }
    }

    render() {
        const { inputWidth, cssClass, rules, yesValue, noValue, dataname, checked, issuanceType  } = this.props;
        const yesId = `${dataname}-yes`;
        const noId = `${dataname}-no`;
        return (
            <div
                style={inputWidth && { width: inputWidth }}
                className={`${cssClass ? cssClass : ""} yesNoRadioButtonWrap${
                    issuanceType ? " yesNoRadioButtonWrap--issuance" : ""
                }`}
            >
                <div className="InputGroup">
                    <input type="radio"
                        name={dataname}
                        id={yesId}
                        value={yesValue}
                        checked={checked === yesValue}
                        dataname={dataname}
                        disabled={!rules.editable}
                        onChange={() => { }}
                    />
                    <label htmlFor={yesId}
                        onClick={(e) => this.handleChange(e, yesValue)}>{issuanceType ? "EASE": "ON"}</label>
                    <input type="radio"
                        name={dataname}
                        id={noId}
                        value={noValue}
                        disabled={!rules.editable}
                        checked={checked === noValue}
                        dataname={dataname}
                        onChange={() => { }}
                    />
                    <label htmlFor={noId}
                        onClick={(e) => this.handleChange(e, noValue)}>{issuanceType ? "NEWGEN": "OFF"}</label>
                </div>
            </div>
        );
    }
}

export default YesNoRadioButton;
